export interface WidgetOptions {
  component: React.FC<any> | React.ComponentClass<any, any>;
  configuration: {
    tagname: string;
  };
}

const widgets: any = {};

export function registerWidget(options: WidgetOptions) {
  widgets[options.configuration.tagname] = options.component;
}

export function getWidgetById(id: string) {
  if (id) {
    return widgets[id] || null;
  }
  return null;
}
